/** tempexp_14729-full-file */
import classNames from 'clsx';
import React, { type FC, memo } from 'react';
import { datalistInlineRenameEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { useRenameInlineDoubleClick } from 'reactApp/hooks/useRenameInlineDoubleClick';
import { EInlineEditPlace } from 'reactApp/modules/modifying/modifying.types';
import { ContentEditable } from 'reactApp/ui/ContentEditable/ContentEditable';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { noop } from 'reactApp/utils/helpers';

import styles from './ItemName.css';

interface ItemNameProps {
    className?: string;
    name: string;
    ext?: string;
    id: string;
    isRenameAvailable?: boolean;
}

export const ItemName: FC<ItemNameProps> = memo(({ className, name, ext, id, isRenameAvailable }) => {
    const { isEdit, handleDoubleClick, onRename } = useRenameInlineDoubleClick(name, id, EInlineEditPlace.datalistThumbs, ext);

    return (
        <div className={classNames(styles.root, className)}>
            {isEdit ? (
                <div className={styles.edit}>
                    <ContentEditable value={name} onEdit={onRename} selectAllOnFocus />
                </div>
            ) : (
                <NameComponent
                    name={name}
                    extension={ext}
                    truncate
                    showTooltip={false}
                    onClick={isRenameAvailable && datalistInlineRenameEnabled ? handleDoubleClick : noop}
                />
            )}
        </div>
    );
});

ItemName.displayName = 'ItemName';
